export default __webpack_public_path__ + "static/media/blaze_site_block_logo.478b7339.svg";